<fieldset [formGroup]="skjema()" data-testid="beslutning-skjema">

  <mat-form-field class="tittel">
    <mat-label>{{ tittelLabel() }}</mat-label>
    <input matInput [formControl]="skjema().controls.tittel" cdkFocusInitial data-testid="tittel-felt">
    @if (skjema().controls.tittel.hasError('maxlength')) {
      <mat-error data-testid="maxlength">{{ skjema().controls.tittel.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
    }
    @if (skjema().controls.tittel.hasError('tittelOgBeskrivelseTom')) {
      <mat-error data-testid="tittelOgBeskrivelseTom">{{ 'Tittel eller utdyping må være fylt ut' | translate }}</mat-error>
    }
  </mat-form-field>

  <mat-form-field class="beskrivelse">
    <mat-label>{{ 'Beslutning - utdyping'|translate }}</mat-label>
    <riktekst-redigering [skjemakontroll]="skjema().controls.beskrivelse" [gruppeId]="gruppeId()" innholdBrukesIPdf="true" data-testid="beslutning-felt"/>
  </mat-form-field>

</fieldset>
